(function () {
  function addBusinessDays(date, days) {
    var result = new Date(date);
    while (days > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0) days--;
    }
    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  }

  function updateCard(card) {
    card.dataset.deliveryInitialized = 'true';

    var dispatchMin = parseInt(card.dataset.dispatchMin, 10) || 0;
    var dispatchMax = parseInt(card.dataset.dispatchMax, 10) || 0;
    var transitMin = parseInt(card.dataset.transitMin, 10) || 0;
    var transitMax = parseInt(card.dataset.transitMax, 10) || 0;

    var today = new Date();
    var earliest = addBusinessDays(today, dispatchMin + transitMin);
    var latest = addBusinessDays(today, dispatchMax + transitMax);

    var dateElement = card.querySelector('.estimated-delivery-date strong');
    if (!dateElement) return;

    dateElement.textContent = (formatDate(earliest) === formatDate(latest))
      ? formatDate(earliest)
      : formatDate(earliest) + ' \u2013 ' + formatDate(latest);
  }

  function collectRoots(root, seen) {
    seen.push(root);
    var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        collectRoots(all[i].shadowRoot, seen);
      }
    }
  }

  function scanAll() {
    var roots = [];
    collectRoots(document, roots);
    for (var i = 0; i < roots.length; i++) {
      var cards = roots[i].querySelectorAll('.estimated-delivery-card:not([data-delivery-initialized])');
      cards.forEach(updateCard);
    }
  }

  scanAll();
  setInterval(scanAll, 400);
})();